import { MouseEventHandler } from "react";
import { Icon } from "@iconify/react";
import { ThemeStyle, useTheme } from "../../hooks/useTheme";

type ThreeDotsButtonProps = {
  onPress: MouseEventHandler<HTMLDivElement>;
  themeProp?: ThemeStyle;
};

const ThreeDotsButton = (props: ThreeDotsButtonProps) => {
  const { onPress, themeProp } = props;
  const { theme } = useTheme();

  return (
    <div
      className="ColumnNormalSelect"
      style={{
        fontSize: 14,
        fontWeight: 600,
      }}
      onClick={onPress}
    >
      <Icon
        icon="ion:ellipsis-horizontal"
        height={20}
        style={{
          color: themeProp
            ? themeProp.PrimaryText.color
            : theme.PrimaryText.color,
        }}
      />
    </div>
  );
};

export default ThreeDotsButton;
